/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PatientVisitInstitutionalDetailsIntegrationViewModel } from './patientVisitInstitutionalDetailsIntegrationViewModel';
import { PatientProcedureTransactionDetailsIntegrationViewModel } from './patientProcedureTransactionDetailsIntegrationViewModel';

export interface PatientVisitDetailsIntegrationViewModel {
  /**
   * External Id, max length 50
   */
  externalId?: string | null;
  /**
   * Visit Reference Number
   */
  referenceNumber?: number;
  /**
   * Accident type, valid values: E = Employment, P = Pregnancy, I = Injury/Illness, O = Other, A = Automobile accident, blank for None
   */
  accidentType?: string | null;
  /**
   * Accident State Code, must be a valid US state
   */
  accidentStateCode?: string | null;
  /**
   * Financial class code for visit
   */
  financialClass?: string | null;
  /**
   * Admit date for inpatient hospital visit
   */
  hospitalAdmitDate?: string | null;
  /**
   * Discharge date for inpatient hospital visit
   */
  hospitalDischargeDate?: string | null;
  /**
   * Illness/injury date
   */
  illnessInjuryDate?: string | null;
  /**
   * Primary Insurance Auth Number for Visit, max length 50
   */
  primaryInsuranceAuthNumber?: string | null;
  /**
   * Secondary Insurance Auth Number for Visit, max length 50
   */
  secondaryInsuranceAuthNumber?: string | null;
  /**
   * Tertiary Insurance Auth Number for Visit, max length 50
   */
  tertiaryInsuranceAuthNumber?: string | null;
  /**
   * Primary Insurance Carrier Name
   */
  primaryInsuranceCarrier?: string | null;
  /**
   * Secondary Insurance Carrier Name
   */
  secondaryInsuranceCarrier?: string | null;
  /**
   * Tertiary Insurance Carrier Name
   */
  tertiaryInsuranceCarrier?: string | null;
  /**
   * Primary Insurance Id
   */
  primaryInsuranceId?: string | null;
  /**
   * Secondary Insurance Id
   */
  secondaryInsuranceId?: string | null;
  /**
   * Tertiary Insurance Id
   */
  tertiaryInsuranceId?: string | null;
  /**
   * Estimated Patient Balance, will be included in ImaginePay Balance
   */
  estimatedPatientBalance?: number | null;
  /**
   * Patient or Insurance Responsible
   */
  responsibleParty?: string | null;
  institutionalFields?: PatientVisitInstitutionalDetailsIntegrationViewModel;
  procedures?: Array<PatientProcedureTransactionDetailsIntegrationViewModel> | null;
}
